import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import { baseGrid, siteWide } from '@helpers/grid';
import { Device, from, until } from '@helpers/media';
import { ComponentTheme } from '@helpers/themeEnum';
import { h5, headingStyles } from '@helpers/typography';
import Accordion from '@stories/Components/Misc/Accordion/Accordion';
import styled from 'styled-components';
const Container = styled.div `
  --bgColour: ${brand.grey.grey16};
  --fgColour: ${brand.white};
  --linkColour: ${brand.green.base};
  background-color: var(--bgColour);
  color: var(--fgColour);
  padding-top: ${fluid(64, 104)};
  padding-bottom: ${fluid(64, 140)};

  &[data-theme=${ComponentTheme.Orange}] {
    --bgColour: ${brand.orange.light};
    --fgColour: ${brand.grey.grey16};
    --linkColour: ${brand.green.link};
  }

  &[data-theme=${ComponentTheme.Green}] {
    --bgColour: ${brand.green.light};
    --fgColour: ${brand.grey.grey16};
    --linkColour: ${brand.green.link};
  }

  &[data-theme=${ComponentTheme.Blue}] {
    --bgColour: ${brand.blue.light};
    --fgColour: ${brand.grey.grey16};
    --linkColour: ${brand.green.link};
  }

  &[data-theme=${ComponentTheme.Yellow}] {
    --bgColour: ${brand.yellow.light};
    --fgColour: ${brand.grey.grey16};
    --linkColour: ${brand.green.link};
  }

  &[data-theme=${ComponentTheme.White}] {
    --bgColour: ${brand.white};
    --fgColour: ${brand.grey.grey16};
    --linkColour: ${brand.green.link};
  }
`;
const Inner = styled.div `
  ${siteWide};
`;
const InnerGrid = styled.div `
  @media ${from(Device.Tablet)} {
    ${baseGrid};
  }
`;
const Title = styled.h2 `
  ${h5};
  margin-bottom: 0;
`;
const ImageWrapper = styled.div `
  display: flex;
  justify-content: center;
  width: 100%;
  margin-top: ${fluid(48, 72)};
  
  @media ${until(Device.Tablet)} {
    width: calc(100% + var(--sitePadding)*2);
    margin-left: calc(var(--sitePadding)*-1);
  }
`;
const SectionImageDesktop = styled.img ``;
const SectionImageMobile = styled(SectionImageDesktop) `
  display: none;

  @media ${until(Device.Tablet)} {
    display: block;

    + ${SectionImageDesktop} {
      display: none;
    }
  }
`;
const AccordionGroup = styled.div `
  padding-top: ${fluid(56, 72)};
`;
const InnerGridColumn = styled.div `
  grid-column: 7 / span 6;

  @media ${from(Device.Tablet)} {
    > ${AccordionGroup} {
      &:first-child {
        padding-top: 0;
      }
    }
  }

  &:first-child {
    grid-column: 1 / span 6;
  }
`;
const AccordionGroupSubheading = styled.h3 `
  ${headingStyles}
  font-size: ${fluid(25, 30)};
  line-height: ${fluid(30, 30)};
`;
const AccordionGroupGrid = styled.div `
  @media ${from(Device.Tablet)} {
    ${baseGrid};
    grid-template-columns: repeat(2, 1fr);
  }
`;
const AccordionListing = styled(Accordion) ``;
const AccordionAnswer = styled.div `

  p {
    a {
      color: var(--linkColour);
    }
  }

  a {
    color: var(--linkColour);
  }

`;
export const FAQsStyles = {
    AccordionAnswer,
    AccordionGroup,
    AccordionGroupGrid,
    AccordionGroupSubheading,
    AccordionListing,
    Container,
    ImageWrapper,
    Inner,
    InnerGrid,
    InnerGridColumn,
    SectionImageDesktop,
    SectionImageMobile,
    Title,
};
